import { useState } from "react";
import SideBar from "./Sidebar";
import { Outlet } from "react-router-dom";
import { CoachRecordingsNotification } from "../coach-recordings/coach-recordings-notification";
import { UserReportsNotification } from "../users-reports/user-reports-notification";
import { FaMoon, FaSun } from "react-icons/fa";
import { useTheme } from "src/context/theme.context";

const Layout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className={`flex flex-col min-h-screen transition-colors duration-300 ${
      isDarkMode ? "bg-gray-950 text-gray-100" : "bg-gray-100 text-gray-900"
    }`}>
      {/* Mobile Header */}
      <div className={`lg:hidden px-4 py-3 flex items-center justify-between transition-colors duration-300 ${
        isDarkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900 border-b border-gray-200"
      }`}>
        <span className="font-bold text-xl">Taaly</span>
        <div className="flex items-center gap-2">
          <button
            onClick={toggleTheme}
            className={`p-2 rounded-lg transition-colors ${
              isDarkMode ? "hover:bg-gray-800 text-yellow-400" : "hover:bg-gray-100 text-gray-700"
            }`}
            title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            {isDarkMode ? <FaSun className="w-5 h-5" /> : <FaMoon className="w-5 h-5" />}
          </button>
          <button
            onClick={toggleMobileMenu}
            className={`p-2 rounded-lg transition-colors ${
              isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-100"
            }`}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>

      {/* Main area: sidebar + content */}
      <div className="flex flex-grow h-full">
        {/* Desktop Sidebar */}
        <div className={`hidden lg:block bg-gray-900 text-white sticky top-0 h-screen transition-all duration-300 ${
          isSidebarCollapsed ? 'w-16' : 'w-64'
        }`}>
          <SideBar isCollapsed={isSidebarCollapsed} onToggle={toggleSidebar} />
        </div>

        {/* Mobile Sidebar Overlay */}
        {isMobileMenuOpen && (
          <div className="lg:hidden fixed inset-0 z-50 flex">
            {/* Backdrop */}
            <div 
              className="fixed inset-0 bg-black bg-opacity-50" 
              onClick={toggleMobileMenu}
            />
            {/* Sidebar */}
            <div className="relative bg-gray-900 text-white w-64 h-full">
              <SideBar isCollapsed={false} onToggle={toggleMobileMenu} />
            </div>
          </div>
        )}

        {/* Content */}
        <div className={`flex-1 overflow-auto py-4 px-4 transition-colors duration-300 ${
          isDarkMode ? "bg-gray-950" : "bg-gray-100"
        }`}>
          <Outlet />
        </div>
      </div>

      <CoachRecordingsNotification />
      <UserReportsNotification />
    </div>
  );
};

export default Layout;
